import { render, staticRenderFns } from "./ArtistGallery.vue?vue&type=template&id=6c4e8d2e&scoped=true"
import script from "./ArtistGallery.vue?vue&type=script&lang=js"
export * from "./ArtistGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4e8d2e",
  null
  
)

export default component.exports